<template>
    <a-modal title="入驻基地" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id"/>
                </a-form-item>
                <a-form-item label="baseId" name="baseId">
                    <a-input v-model:value="form.baseId"/>
                </a-form-item>
                <a-form-item label="companyCode" name="companyCode">
                    <a-input v-model:value="form.companyCode"/>
                </a-form-item>
            </div>
            <a-row :gutter="24">
                <a-col :span="24">
                    <a-form-item label="楼宇" name="building">
                        <a-input v-model:value="form.building" placeholder="请输入楼宇"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="楼层" name="storey">
                        <a-input v-model:value="form.storey" placeholder="请输入楼层"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="房间号" name="room">
                        <a-input v-model:value="form.room" placeholder="请输入房间号"/>
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
// import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {companyBaseApi} from "@/api/innovationService";
import {innovation} from "@/config/variableConfig"

export default {
    name: "AddOrEditModal",
    mixins: [formMixin],
    data() {
        return {
            innovation,
            form: {
                id: null,
                baseId: null,
                companyCode: null,
                building: null,
                storey: null,
                room: null,

            },
            rules: {
                id:[],
                baseId:[],
                companyCode:[],
                building:[],
                storey:[],
                room:[],

            },

            options: [],
            // postMethod: 'post_json'

            submitUrl: companyBaseApi.saveOrUpdate
        }
    },
    created() {
    },
    methods: {},
}
</script>
<style scoped lang="less">
</style>
